<template>
  <button :class="$style.headerCart"
          @click="toggleCart">
    <svg v-svg
         :class="$style.headerCartIcon"
         symbol="cart-icon"/>
    <span v-if="cartLength"
          :class="$style.cartBadge">
      {{ cartLength }}
    </span>
  </button>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Getter, Mutation } from 'vuex-class';
import { CART_DISPLAY } from '@/apps/cart/store/types';

/**
 * Button to display cart item count and open cart navigation drawer.
 */
@Component
export default class DesktopCartIcon extends Vue {
  @Getter cartLength;
  @Getter showCart;
  @Mutation(CART_DISPLAY) cartDisplay;

  toggleCart() {
    this.cartDisplay(!this.showCart);
  }
}
</script>

<style lang="scss" module>
@import "~@/style/variables.scss";

.headerCart {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 23px;
  position: relative;
  outline: none;

  .headerCartIcon {
    width: 24px;
    height: 24px;
    fill: $white;
  }
}

.cartBadge {
  position: absolute;
  top: 0;
  right: -8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: $green2;
  color: $white;
  text-align: center;
  font-family: 'Gotham', sans-serif;
  font-weight: 700;
  font-size: 9px;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopCartIcon.vue